import styled from "styled-components";
import StyledButton from "./Button.tsx";
import React from "react";

const Container = styled.div`
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 31, 82, 0.1);
  transition: background 0.3s ease, box-shadow 0.3s ease;

  .dark-mode & {
    background: #2a2a3e;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
`;

const PageButton = styled(StyledButton)`
  margin: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: #ccc;
    color: #666;
  }

  .dark-mode &:disabled {
    background-color: #3a3a4e;
    color: #999;
  }
`;

const PageLabel = styled.span`
  margin: 0;
  color: #001f52;
  font-weight: 600;
  font-size: 0.95rem;
  transition: color 0.3s ease;

  .dark-mode & {
    color: #e0e0e0;
  }
`;

interface Props {
  page: number;
  pageSize: number;
  totalItems: number;
  onChange: (page: number) => void;
}

export default function Pagination({
  page,
  pageSize,
  totalItems,
  onChange,
}: Props) {
  const totalPages = Math.ceil(totalItems / pageSize);

  if (totalPages <= 1) return null;

  return (
    <Container>
      <PageButton
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
      >
        Forrige
      </PageButton>

      <PageLabel>
        {page} / {totalPages}
      </PageLabel>

      <PageButton
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
      >
        Næste
      </PageButton>
    </Container>
  );
}